import { LitElement, html, nothing } from 'lit';
import { createRef, ref } from 'lit/directives/ref.js';
import '@shoelace-style/shoelace/dist/components/input/input.js';
import '@shoelace-style/shoelace/dist/components/color-picker/color-picker.js';
import { DEFAULT_TAGS } from './DefaultTags';

export class CreateTagDialog extends LitElement {
  static properties = {
    modelPath: { type: String },
    _newTagName: { type: String },
    _newTagColor: { type: String },
    _errorMessage: { type: String }
  };

  constructor() {
    super();
    this._createTagDialog = createRef();
    this.allSelectableTags = {};
    this.modelPath = '';
    this._errorMessage = '';
  }

  render() {
    return html`
      <katapult-dialog ${ref(this._createTagDialog)} icon="new_label" title="New Tag" width="400">
        <div style="display: flex; justify-content: center; align-items: center;">
          <sl-color-picker
            value=${this._newTagColor}
            hoist
            @sl-change=${(e) => (this._newTagColor = e.target.value)}
            format="hex"
          ></sl-color-picker>
          <sl-input
            placeholder="Enter a Tag Name"
            value=${this._newTagName}
            size="medium"
            @sl-change=${(e) => (this._newTagName = e.target.value)}
            style="margin-left: var(--sl-spacing-small);"
            pill
          ></sl-input>
        </div>
        ${this._errorMessage
          ? html`<span style="margin-top: var(--sl-spacing-small); font-style: italic;">${this._errorMessage}</span>`
          : nothing}
        <div slot="buttons">
          <katapult-button .callback=${this.#addTag.bind(this)} color="var(--secondary-color)">Add</katapult-button>
          <katapult-button dialog-dismiss>Cancel</katapult-button>
        </div>
      </katapult-dialog>
    `;
  }

  #showError(message) {
    this._errorMessage = message;
    throw new Error(message);
  }

  async #addTag() {
    if (!this.modelPath) this.#showError('A model path is required to complete this action');
    if (!this._newTagName || !this._newTagColor) this.#showError('Tag name and color are required');

    // Don't allow tag names that are the same as default tag names
    const tagNameMatchesDefaults = Object.values(DEFAULT_TAGS ?? {}).some(
      (tagData) => tagData.name?.toLowerCase() == this._newTagName.toLowerCase()
    );
    if (tagNameMatchesDefaults) this.#showError('Tag name matches an existing default tag');

    // Push the tag to the database
    const ref = globalThis.FirebaseWorker.ref(this.modelPath).child('models/tags');
    await ref.push({ color: this._newTagColor, name: this._newTagName });

    // clear the values and close the dialog
    this._newTagColor = '';
    this._newTagName = '';
    this._errorMessage = '';
    this._createTagDialog?.value?.close();
  }

  open() {
    this._createTagDialog?.value?.open();
  }
}
customElements.define('create-tag-dialog', CreateTagDialog);
